import { isResourceDetailNotepad } from '../../resources/utils/resourceDetailGuards.js';

const mutateNotepadContentV2 = (resource, preview) => {
  if (isResourceDetailNotepad(resource)) {
    return {
      ...resource,
      data: {
        ...resource.data,
        preview: {
          ...resource.data.preview,
          ...preview,
          content: preview?.content || resource.data.preview?.content || ""
        }
      }
    };
  }
  return resource;
};

export { mutateNotepadContentV2 };
//# sourceMappingURL=mutateNotepadContent.js.map
